import classNames from 'classnames';

interface ToggleableClassname {
    classname: string;
    hideClassname?: boolean;
}

export const combineToggleableClassnames = (
    ...toggleableClassnames: ToggleableClassname[]
) =>
    classNames(
        ...toggleableClassnames
            .filter((c) => !c.hideClassname)
            .map((c) => c.classname)
    );
